__turbopack_context__.v({
  "accordionDivider": "subscription-module-scss-module__pVWWja__accordionDivider",
  "accordionText": "subscription-module-scss-module__pVWWja__accordionText",
  "accordionTitle": "subscription-module-scss-module__pVWWja__accordionTitle",
  "balanceBox": "subscription-module-scss-module__pVWWja__balanceBox",
  "balanceBox_corporate": "subscription-module-scss-module__pVWWja__balanceBox_corporate",
  "balanceBox_hidden": "subscription-module-scss-module__pVWWja__balanceBox_hidden",
  "balanceContainer": "subscription-module-scss-module__pVWWja__balanceContainer",
  "blocksMapper": "subscription-module-scss-module__pVWWja__blocksMapper",
  "cancelSubscriptionButton": "subscription-module-scss-module__pVWWja__cancelSubscriptionButton",
  "cancelSubscriptionButtonCancel": "subscription-module-scss-module__pVWWja__cancelSubscriptionButtonCancel",
  "cancelSubscriptionButtonKeep": "subscription-module-scss-module__pVWWja__cancelSubscriptionButtonKeep",
  "cancelSubscriptionButtonTooltipTarget": "subscription-module-scss-module__pVWWja__cancelSubscriptionButtonTooltipTarget",
  "cancelSubscriptionButtonWrapper": "subscription-module-scss-module__pVWWja__cancelSubscriptionButtonWrapper",
  "cancelSubscriptionModalButtons": "subscription-module-scss-module__pVWWja__cancelSubscriptionModalButtons",
  "cancelSubscriptionModalContainer": "subscription-module-scss-module__pVWWja__cancelSubscriptionModalContainer",
  "cancelSubscriptionModalText": "subscription-module-scss-module__pVWWja__cancelSubscriptionModalText",
  "cancelSubscriptionModalTextEmphasis": "subscription-module-scss-module__pVWWja__cancelSubscriptionModalTextEmphasis",
  "cancelSubscriptionModalTitle": "subscription-module-scss-module__pVWWja__cancelSubscriptionModalTitle",
  "container": "subscription-module-scss-module__pVWWja__container",
  "featureBlock": "subscription-module-scss-module__pVWWja__featureBlock",
  "featureDivider": "subscription-module-scss-module__pVWWja__featureDivider",
  "featureHeader": "subscription-module-scss-module__pVWWja__featureHeader",
  "featureIcon": "subscription-module-scss-module__pVWWja__featureIcon",
  "featureItem": "subscription-module-scss-module__pVWWja__featureItem",
  "featureText": "subscription-module-scss-module__pVWWja__featureText",
  "featureTitle": "subscription-module-scss-module__pVWWja__featureTitle",
  "featureUnit": "subscription-module-scss-module__pVWWja__featureUnit",
  "infoIcon": "subscription-module-scss-module__pVWWja__infoIcon",
  "infoText": "subscription-module-scss-module__pVWWja__infoText",
  "infoUnderText": "subscription-module-scss-module__pVWWja__infoUnderText",
  "planInfoRow": "subscription-module-scss-module__pVWWja__planInfoRow",
  "selectContainer": "subscription-module-scss-module__pVWWja__selectContainer",
  "selectMenuItem": "subscription-module-scss-module__pVWWja__selectMenuItem",
  "selectMenuList": "subscription-module-scss-module__pVWWja__selectMenuList",
  "selectMenuPaper": "subscription-module-scss-module__pVWWja__selectMenuPaper",
  "subTitle": "subscription-module-scss-module__pVWWja__subTitle",
  "subscriptionFeatures": "subscription-module-scss-module__pVWWja__subscriptionFeatures",
  "title": "subscription-module-scss-module__pVWWja__title",
  "toggleBadge": "subscription-module-scss-module__pVWWja__toggleBadge",
  "tokenSelect": "subscription-module-scss-module__pVWWja__tokenSelect",
});
